const isScrollable = function( ele )
{
    const hasScrollableContent = ele.scrollHeight > ele.clientHeight;

    const overflowYStyle = window.getComputedStyle(ele).overflowY;
    const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

    return hasScrollableContent && !isOverflowHidden;
};

const getScrollableParent = function( ele )
{
    if( !ele || ele === document.body ){ return document.body }

    if( ['DatePicker','Select'].includes( ele.className ) || ['LABEL'].includes( ele.tagName ) )
    {
        return getScrollableParent( ele.parentNode );
    }
    else
    {
        return isScrollable(ele) ? ele : getScrollableParent( ele.parentNode )
    }
};

export default
{
    mounted( el, { instance } )
    {
        if( instance.appendToBody )
        {
            let contentElement = getScrollableParent( instance.$refs.rootElement );

            el.handleScrollPosition = () =>
            {
                if( instance.$refs?.toggle?.getBoundingClientRect() && instance?.$refs?.dropdown?.getBoundingClientRect() ) //TODO FIX THIS BUG => cannot be undefined
                {
                    const w_width = window.innerWidth, w_height = window.innerHeight;

                    const { width: t_width, height: t_height, top: t_top, left: t_left, bottom: t_bottom, right: t_right } = instance.$refs.toggle.getBoundingClientRect();
                    const { width: d_width, height: d_height, top: d_top, left: d_left, bottom: d_bottom, right: d_right } = instance.$refs.dropdown.getBoundingClientRect();

                    const direction = window.scrollY + t_top + t_height + d_height > w_height ? 'bottom' : 'top';

                    instance.calculatePosition( el, instance,
                    {
                        width   : t_width,
                        top     : ( direction === 'bottom' ) ? ( window.scrollY + t_bottom - t_height - d_height ) : ( window.scrollY + t_top + t_height ),
                        left    : ( window.scrollX + t_left ),
                        right   : t_right,
                        direction
                    });
                }
            }

            contentElement.addEventListener('scroll', el.handleScrollPosition );

            el.handleScrollPosition();

            document.body.appendChild( el );
        }
    },

    unmounted( el, { instance } )
    {
        if( instance.appendToBody )
        {
            if( el.handleScrollPosition && typeof el.handleScrollPosition === 'function' )
            {
                let contentElement = getScrollableParent( instance.$refs.rootElement );

                contentElement.removeEventListener('scroll', el.handleScrollPosition )
            }

            if( el.parentNode )
            {
                el.parentNode.removeChild( el );
            }
        }
    }
}